// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__MP08G","infoBtn":"quickbooks_infoBtn__2aWQv","formBox":"quickbooks_formBox__1jImZ","formFooter":"quickbooks_formFooter__1mwu1"};